export default function ComparisonChecklist() {
  const checklistItems = [
    'Licensed and insured flooring contractor',
    'Detailed written estimates with material costs',
    'Portfolio of completed El Paso flooring projects',
    'Experience with your specific flooring type',
    'Subfloor inspection and preparation included',
    'Furniture moving and disposal services',
    'Warranty on installation and materials',
    'Timeline and project completion date',
    'References from recent customers',
    'Proper acclimation time for materials'
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-5xl mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Flooring Contractor Comparison Checklist
          </h2>
          <p className="text-xl text-gray-600">
            Essential factors to consider when choosing a flooring contractor in El Paso for your installation project
          </p>
        </div>

        <div className="bg-gradient-to-br from-teal-50 to-white rounded-2xl p-8 md:p-12 shadow-lg border border-teal-100">
          <div className="grid md:grid-cols-2 gap-4">
            {checklistItems.map((item, index) => (
              <div
                key={index}
                className="flex items-start gap-3 p-4 bg-white rounded-lg hover:shadow-md transition-shadow"
              >
                <div className="w-6 h-6 bg-teal-600 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-check-line text-white text-sm"></i>
                </div>
                <span className="text-gray-700 leading-relaxed">{item}</span>
              </div>
            ))}
          </div>

          <div className="mt-8 p-6 bg-teal-600 rounded-xl text-white text-center">
            <p className="text-lg font-medium">
              Ready to upgrade your floors with professional installation?
            </p>
            <a
              href="#contact"
              className="inline-block mt-4 px-8 py-3 bg-white text-teal-600 font-semibold rounded-lg hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer"
            >
              Get Free Estimate
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
